<template>
  <b-modal
    id="modalReprocessSale"
    centered
    title="Reprocess sale"
    title-class="font-18"
    size="md"
    @hide="resetForm"
  >
    <div class="mb-3">
      <label for="sale_id" class="form-label">ID da Venda</label>
      <b-form-input
        id="sale_id"
        v-model="sale_id"
        placeholder="Digite o ID da venda"
        type="number"
        :state="!errorsForms.sale_id"
      />
      <b-form-invalid-feedback v-if="errorsForms.sale_id">
        {{ errorsForms.sale_id }}
      </b-form-invalid-feedback>
    </div>

    <div class="mb-3">
      <label for="status" class="form-label">Status</label>
      <b-form-select
        id="status"
        v-model="status"
        :options="statusOptions"
        :state="!errorsForms.status"
      />
      <b-form-invalid-feedback v-if="errorsForms.status">
        {{ errorsForms.status }}
      </b-form-invalid-feedback>
    </div>

    <div class="mb-3">
      <label for="queues" class="form-label">Filas (queues)</label>
      <b-form-textarea
        id="queues"
        v-model="queues"
        placeholder="Ex: _receipt,_callback,_email"
        rows="3"
        :state="!errorsForms.queues"
      />
      <b-form-invalid-feedback v-if="errorsForms.queues">
        {{ errorsForms.queues }}
      </b-form-invalid-feedback>
    </div>

    <template v-slot:modal-footer="{ cancel }">
      <div class="d-flex justify-content-around w-100">
        <b-button @click="cancel">Cancelar</b-button>
        <b-button variant="success" @click="submitData">Reprocessar</b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import ReprocessSale from '@services/resources/OperationsService';

const reprocessSale = ReprocessSale.build();

export default {
  name: 'modalReprocessSale',
  data() {
    return {
      sale_id: '',
      status: 'paid',
      queues: '_receipt,_callback,_email,_notification,_pagarme,_notas,_antifraude,_antifraude_geoip,_lead,_webhook,_possale,_release,_send_messages_sale_paid,_send_messages_sale_refund,refund_solicitation_email_sent,_sale_refund_message',
      errorsForms: {},
      statusOptions: [
        { value: 'paid', text: 'Paid' },
        { value: 'refused', text: 'Refused' },
        { value: 'refunded', text: 'Refunded' },
        { value: 'chargedback', text: 'ChargedBack' },
        { value: 'waiting_payment', text: 'Waiting Payment' },
      ]
    };
  },
  methods: {
    validateFields() {
      this.errorsForms = {};

      if (!this.sale_id.toString().trim()) {
        this.errorsForms.sale_id = 'O campo ID da Venda é obrigatório.';
      }

      if (!this.status.trim()) {
        this.errorsForms.status = 'O campo Status é obrigatório.';
      }

      if (!this.queues.trim()) {
        this.errorsForms.queues = 'O campo Filas é obrigatório.';
      }

      return Object.keys(this.errorsForms).length === 0;
    },
    async submitData() {
      if (!this.validateFields()) return;

      try {
        const payload = {
          id: this.sale_id,
          status: this.status,
          queues: this.queues
        };

        await reprocessSale.post('reprocess-sale', payload);

        this.$bvToast.toast('Venda reprocessada com sucesso!', {
          title: 'Sucesso',
          variant: 'success',
          solid: true
        });

        this.$bvModal.hide('modalReprocessSale');
        this.resetForm();
      } catch (error) {
        let message = 'Erro ao enviar';

        if (
          error.response &&
          error.response.status === 422 &&
          typeof error.response.data === 'string'
        ) {
          const parsed = JSON.parse(error.response.data);
          if (parsed.errors) {
            message = Object.values(parsed.errors).flat().join('\n');
          }
        } else if (
          error.response &&
          typeof error.response.data === 'object' &&
          error.response.data.message
        ) {
          message = error.response.data.message;
        } else if (error.message) {
          message = error.message;
        }

        this.$bvToast.toast(message, {
          title: 'Erro',
          variant: 'danger',
          solid: true
        });
      }
    },
    resetForm() {
      this.sale_id = '';
      this.status = 'paid';
      this.queues = '_receipt,_callback,_email,_notification,_pagarme,_notas,_antifraude,_antifraude_geoip,_lead,_webhook,_possale,_release';
      this.errors = {};
    }
  }
};
</script>
